skrilla.service('userExclusionsService', function($q, searchService) {

    let requesters = [];
    let exclusionTypes = [];

    const getRequesterTypes = function (path) {
        const deferred = $q.defer();
        if (requesters.length === 0) {
            searchService.get(`${path === 'sports' ? 'sportsExclusions' : 
                path === 'person' ? 'excludedPersonsRegister' : ''}/requesters`).then(function (response) {
                requesters = response.data;
                deferred.resolve(requesters);
            });
        } else {
            deferred.resolve(requesters);
        }
        return deferred.promise;
    };

    const getExclusionTypes = function () {
        const deferred = $q.defer();
        if (exclusionTypes.length === 0) {
            searchService.get("excludedPersonsRegister/exclusionTypes").then(function (response) {
                exclusionTypes = response.data;
                deferred.resolve(exclusionTypes);
            });
        } else {
            deferred.resolve(exclusionTypes);
        }
        return deferred.promise;
    };

    const getEffectiveUntilColour = function (effectiveUntil) {
        const date = new Date(effectiveUntil)
        const now = new Date()
        return !effectiveUntil ? "light-red" : now < date ? "light-orange" : "light-green"
    }

    return {
        getRequesterTypes: getRequesterTypes,
        getExclusionTypes: getExclusionTypes,
        getEffectiveUntilColour: getEffectiveUntilColour,
    };

});